import admin from './admin';
import approverTypes from './approverTypes';
import areas from './areas';
import auth from './auth';
import contractItems from './contractItems';
import contracts from './contracts';
import deliverables from './deliverables';
import demands from './demands';
import demandOwnerSubstitutions from './demandOwnerSubstitutions';
import demandTypes from './demandTypes';
import evaluations from './evaluations';
import offices from './offices';
import persons from './persons';
import suppliers from './suppliers';
import systems from './systems';
import units from './units';

export default {
    admin,
    approverTypes,
    areas,
    auth,
    contractItems,
    contracts,
    deliverables,
    demands,
    demandOwnerSubstitutions,
    demandTypes,
    evaluations,
    offices,
    persons,
    suppliers,
    systems,
    units,
};



// WEBPACK FOOTER //
// ./src/api/index.js